// extracted by mini-css-extract-plugin
export default {"ClientDetail":"TaskList_ClientDetail__lw9G3","tableResponsive":"TaskList_tableResponsive__cRI65"};